import { CellProps } from 'react-table'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { UsuariosActionsCell } from './UsuariosActionsCell'
import { TFunction } from '_metronic/i18n/Metronici18n'
import { PlainHeader, sortableColumn, StackedCell, StatusBadge, TableColumn } from 'app/components'
import { UsuarioList } from '../../core/_models'

export const UsuariosColumns = (t: TFunction): ReadonlyArray<TableColumn<UsuarioList>> => [
  // Nome com o e-mail como apoio; os dois seguem ordenáveis.
  sortableColumn<UsuarioList>({
    id: 'pessoa.nome',
    useQueryRequest,
    fields: [
      { field: 'pessoa.nome', label: t('nome.label') },
      { field: 'email', label: t('email.label') },
    ],
    Cell: ({ row }: CellProps<UsuarioList>) => (
      <StackedCell
        primary={row.original.nomeSocial || row.original.nome}
        secondary={row.original.email}
      />
    ),
  }),
  sortableColumn<UsuarioList>({
    id: 'ativo',
    cellWidth: '128px',
    useQueryRequest,
    fields: [{ field: 'ativo', label: t('cols.situacao') }],
    Cell: ({ row }: CellProps<UsuarioList>) => <StatusBadge active={row.original.ativo} />,
  }),
  {
    Header: () => <PlainHeader>{t('cols.actions')}</PlainHeader>,
    id: 'actions',
    cellWidth: '132px',
    align: 'end',
    Cell: ({ row }: CellProps<UsuarioList>) => <UsuariosActionsCell usuario={row.original} />,
  },
]
